import Vue from 'vue'
import Router from 'vue-router'

import store from '@/store.js'
import mainpage from '@/components/mainpage'
import privilege_error from '@/components/admin/privilege_error'
import user_error from '@/components/user_error'
import profile from '@/components/admin/profile'
import login from '@/components/login'

import customers from '@/components/customers/customers'
import customer from '@/components/customers/customer'
import history from '@/components/customers/history'
import customer_search from '@/components/customers/customer_search'
import new_customer from '@/components/customers/new_customer'

import managers from '@/components/admin/managers/managers'
import manager from '@/components/admin/managers/manager'
import new_manager from '@/components/admin/managers/new_manager'

import categories from '@/components/admin/categories/categories'
import category from '@/components/admin/categories/category'
import new_category from '@/components/admin/categories/new_category'

import types from '@/components/admin/types/types'
import type from '@/components/admin/types/type'
import new_type from '@/components/admin/types/new_type'

import products from '@/components/admin/products/products'
import product from '@/components/admin/products/product'
import new_product from '@/components/admin/products/new_product'

import new_order from '@/components/orders/new_order/new_order'
import order_customer from '@/components/orders/new_order/order_customer'
import order_products from '@/components/orders/new_order/order_products'
import order_products_v2 from '@/components/orders/new_order/order_products2'
import ordersum from '@/components/orders/new_order/order_sum'
import order from '@/components/orders/single_order'
import billings from '@/components/orders/billings'
import balanced from '@/components/orders/balanced'

import gordulo from '@/components/stats/gordulo'
import kimikor from '@/components/stats/kimikor'

import order_list from '@/components/orders/order_list/order_list'
import order_search from '@/components/orders/order_list/order_search'

import webOrderSearch from '@/components/webOrders/search'

import taskSearch from '@/components/tasks/taskSearch'
import addTask from '@/components/tasks/addTask'
import editTask from '@/components/tasks/editTask'

import inquiringList from '@/components/inquiring/list'
import inquiringCreate from '@/components/inquiring/create'
import inquiringEdit from '@/components/inquiring/edit'

import lists from '@/components/lists/lists'

import inventoryList from '@/components/inventory/list'

Vue.use(Router)

const isAuthenticated = (to, form, next) => {
  if (store.getters.token === null) {
    next('/login')
    return
  }
  next()
}

const isAdmin = (to, from, next) => {
  if (store.getters.token !== null) {
    if (store.getters.user.admin === 0) {
      next('/privilege_error')
    }
    next()
  }
}

export default new Router({
	mode: 'history',
  	routes: [
      { path: '/', name: 'mainpage', component: mainpage, beforeEnter: isAuthenticated},
      { path: '/privilege_error', name: 'privilege_error', component: privilege_error},
      { path: '/user_error', name: 'user_error', component: user_error},
      { path: '/profile', name: 'profile', component: profile, beforeEnter: isAuthenticated},
      { path: '/login', name: 'login', component: login },
      { path: '/customers', name: 'customers', component: customers, beforeEnter: isAuthenticated },
      { path: '/customers/history/:id', name: 'orderhistory', component: history, beforeEnter: isAuthenticated },
      { path: '/customer/:id', name: 'customer', component: customer, beforeEnter: isAuthenticated },
      { path: '/customers/search', name: 'customer_search', component: customer_search, beforeEnter: isAuthenticated },
      { path: '/customers/new_customer', name: 'new_customer', component: new_customer, beforeEnter: isAuthenticated },
      { path: '/orders/new_order', name: 'new_order', component: new_order, beforeEnter: isAuthenticated,
        children: [
          { path: 'customer', component: order_customer },
          { path: 'products', component: order_products },
          { path: 'products_v2', component: order_products_v2 }
        ]
      },
      { path: '/order/:id', name: 'order', component: order, beforeEnter: isAuthenticated },
      { path: '/orders/ordersum', name: 'ordersum', component: ordersum, beforeEnter: isAuthenticated },
      { path: '/orders/order_list', name: 'order_list', component: order_list, beforeEnter: isAuthenticated },
      { path: '/orders/search', name: 'order_search', component: order_search, beforeEnter: isAuthenticated },
      { path: '/orders/billings', name: 'billings', component: billings, beforeEnter: isAuthenticated },
      { path: '/orders/balanced', name: 'balanced', component: balanced, beforeEnter: isAuthenticated },
      { path: '/managers', name: 'managers', component: managers, beforeEnter: isAuthenticated },
	    { path: '/manager/:id', name: 'manager', component: manager, beforeEnter: isAdmin },
      { path: '/managers/new_manager', name: 'new_manager', component: new_manager, beforeEnter: isAdmin },
      { path: '/categories', name: 'categories', component: categories, beforeEnter: isAuthenticated},
      { path: '/categories/:id', name: 'category', component: category, beforeEnter: isAdmin },
      { path: '/category/new_category', name: 'new_category', component: new_category, beforeEnter: isAdmin },
      { path: '/types', name: 'types', component: types, beforeEnter: isAuthenticated },
      { path: '/types/:id', name: 'type', component: type, beforeEnter: isAdmin },
      { path: '/type/new_type', name: 'new_type', component: new_type, beforeEnter: isAdmin },
      { path: '/products', name: 'products', component: products, beforeEnter: isAuthenticated },
      { path: '/products/:id', name: 'product', component: product, beforeEnter: isAdmin },
      { path: '/product/new_product', name: 'new_product', component: new_product, beforeEnter: isAdmin },
      { path: '/stats/gordulo', name: 'gordulo', component: gordulo, beforeEnter: isAuthenticated },
      { path: '/stats/kimikor', name: 'kimikor', component: kimikor, beforeEnter: isAuthenticated },
      { path: '/tasks/search', component: taskSearch, beforeEnter: isAuthenticated },
      { path: '/tasks/add_task', component: addTask, beforeEnter: isAuthenticated },
      { path: '/tasks/edit/:id', component: editTask, beforeEnter: isAuthenticated },
      { path: '/inquiring/create', component: inquiringCreate, beforeEnter: isAuthenticated },
      { path: '/inquiring/list', component: inquiringList, beforeEnter: isAuthenticated },
      { path: '/inquiring/edit/:id', component: inquiringEdit, beforeEnter: isAuthenticated },
      { path: '/weborder/list', component: webOrderSearch, beforeEnter: isAuthenticated },
      { path: '/lists', component: lists, beforeEnter: isAdmin },
      { path: '/inventory/list', component: inventoryList, beforeEnter: isAuthenticated },
	    { path: '*', redirect: '/' }
  	]
})



// WEBPACK FOOTER //
// ./src/router/index.js